import styled from 'styled-components';
import { KeywordsStyled } from '../KeywordsStyled';
import { rem } from 'polished';

export const KeywordsStyledDS = styled(KeywordsStyled)`
    font-size: ${rem(14)};
    color: ${({ theme }) => theme.colors.grey29};
`;
